import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Points from "./Points";
import Login from "./Login";
import "bootstrap/dist/css/bootstrap.min.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <div id="grad" class="vh-100">
      <App />
      <Login />
      <Points />
      <hr />
      <div>
        Debug Options <a href="/reset">Clear Login</a> <a href="/">main page</a>
      </div>
    </div>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
